import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import './image-generated.css'

const ImageGenerated = (props) => {
  const { photoUrl } = props;

  const src = {
    'Anger':'/playground_assets/angry-200h.png',
    'Disgust':'/playground_assets/sick-200h.png',
    'Fear':'/playground_assets/scare [1]-200h.png ',
    'Happiness':'/playground_assets/smiley-200h.png',
    'Neutral':'/playground_assets/confusing-200h.png',
    'Sadness':'/playground_assets/white simple letter m logo [1]-200h.png',
    'Surprise':'/playground_assets/surprised-200h.png'
  }

  return (
    <Fragment>
      <div className={`image-generated-container ${props.rootClassName} `} style={{background: `url("${props.image_background}")` }}>
        <h1 className="image-generated-text">{props.heading}</h1>
        <img
          alt={props.image_alt}
          src={src[props.emotion]}
          className="image-generated-image"
        />
      </div>
      <div className='image-generated-back' style={{background: `url("${photoUrl}")` }} />
    </Fragment>
  )
}

ImageGenerated.defaultProps = {
  rootClassName: '',
  image_src:
    '/playground_assets/white%20simple%20letter%20m%20logo%20%5B1%5D-500h.png',
  heading: 'Loading your image and phrase',
  image_alt: 'image',
}

ImageGenerated.propTypes = {
  rootClassName: PropTypes.string,
  image_src: PropTypes.string,
  heading: PropTypes.string,
  image_alt: PropTypes.string,
}

export default ImageGenerated
